module.exports = __webpack_public_path__ + "media/images/flags/CI-a36048db804ec373c83dee04437a2c55.svg";